import { Injectable } from '@angular/core';
import { ValidationExecutionDTO } from '../app/api/plyca-dtos-v2';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../app/ServiceLocator';
import { UIService } from '../app/ui.service';
import { DynamicDialogRef } from 'primeng-lts/dynamicdialog';

@Injectable()
export class PlycaErrorHandler {
  private translationService: TranslateService;

  constructor(
    public uiService: UIService,
  ) {
    this.translationService = ServiceLocator.injector.get(TranslateService);
  }


  public showServerError(error: any): DynamicDialogRef {
    console.error(error);
    return this.uiService.showMessage(this.getErrorMessage(error), this.translationService.instant('General.error'));
  }

  public getErrorMessage(error: any, defaultMesage?: string): string {
    let errMessge: string;
    if (typeof (error) === 'string') {
      errMessge = error;
    } else {
      console.error('Recibido error del servidor:', error);
      errMessge = error.message;
      if (!error.status) {
        // a este metodo se puede llegar como resultado de un error HttpErrorResponse,
        // o como resultado de una peticion HTTP de validacion  ValidationResultDTO
        // para mantener un codigo uniforme envolvemos ValidationResultDTO en un HttpErrorResponse
        error = {
          status: 400,
          error: error
        }
      }
      if (error.status === 404) {
        errMessge = this.translationService.instant('DossierActions.error.noAvailable');
      } else if (error.status === 405) {
        errMessge = this.translationService.instant('General.errorMessage');
      } else if (error.status === 500) { // error.status === 500 ||
        if (error?.error?.message) {
          errMessge = error?.error?.message
        } else {
          errMessge = this.translationService.instant('General.errorMessage');
        }

      } else if (error.status === 400 && error.error) {
        // Error de validacion
        let errorObj = error.error;
        if (errorObj) {
          if (errorObj.errors) {
            let errores: Array<ValidationExecutionDTO> = errorObj.errors;
            let errorType = errorObj.result === 'ERROR' ? 'General.error' : 'General.warning';
            errMessge =
              this.translationService.instant(errorType) + ':<br><ul>';
            errores.forEach((errorVal: ValidationExecutionDTO) => {
              errMessge += '<li>' + errorVal.message + '</li>';
            });
            errMessge += '</ul>';
          } else {
            if (errorObj.message) {
              errMessge = errorObj.message;
            }
            if (errorObj.cause && errorObj.cause.constraintViolations) {
              errMessge += ':<br><ul>';
              let constraintViolations: Array<any> =
                errorObj.cause.constraintViolations;
              constraintViolations.forEach(
                (constraintViolation: any) =>
                  (errMessge += '<li>' + constraintViolation.message + '</li>')
              );
              errMessge += '</ul>';
            }
          }
        }
      } else if (error.error && error.error.msg && error.error.path) {
        // mensajes de error devueltos por la clase HttpExceptionSerializer
        errMessge = error.error.msg;
      } else if (!errMessge) {
        errMessge = (defaultMesage) ? defaultMesage : this.translationService.instant('General.errorMessage');
      }
    }
    return errMessge;
  }

}
